// extracted by mini-css-extract-plugin
export default {"mainContainer":"FooterAtBridalMakeups_mainContainer__7dKhF","mainContent":"FooterAtBridalMakeups_mainContent__+FFUl","secCopyright":"FooterAtBridalMakeups_secCopyright__O7kRh"};